import { render, staticRenderFns } from "./playlists.vue?vue&type=template&id=c064e9d8&scoped=true&"
import script from "./playlists.vue?vue&type=script&lang=ts&"
export * from "./playlists.vue?vue&type=script&lang=ts&"
import style0 from "./playlists.vue?vue&type=style&index=0&id=c064e9d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c064e9d8",
  null
  
)

export default component.exports